<template>
  <div class="member-id--wrapper m-prfilemtb">
    <div class="md-layout md-gutter">
      <!-- Right Column -->
      <div class="md-layout-item md-xlarge-size-33 md-large-size-33 md-small-size-100">
        <!-- Avatar Card -->
        <div class="card name">
          <div class="avatar">
            <img class="circle-image" v-if="member.imageURL" :src="member.imageURL" alt="member photo">
            <img class="circle-image" v-if="!member.imageURL" src="../assets/person.png" alt="member photo">
          </div>
          <div class="sub-title md-body-1 capitalize">{{member.memberType }}</div>
           <template v-if="member.isDeleted && member.isDeleted.status === true">
            <div class="md-body-1 unsubscribe font-18">Deleted: {{member.isDeleted.when | momentDate}}</div>
          </template>
          <!-- <template v-else-if="member.unsubscribe && member.unsubscribe.status === 'unsubscribed'">
            <div class="md-body-1 unsubscribe font-18">Unsubscribed: {{member.unsubscribe.when | momentDate}}</div>
          </template> -->
          <template v-if="member.member_status == true">
            <div class="md-title">
                {{ member.first }} {{ member.last }}
                <template v-if="memberFlag == 'Flagged'">
                    <svg id="cis-flag-alt" viewBox="0 0 512 512" class="flag-svg">
                        <polygon fill="var(--ci-primary-color, #CC0000)" points="432 72 104 72 104 16 56 16 56 496 104 496 104 344 432 344 432 328 344 208 432 88 432 72" class="ci-primary"></polygon>
                    </svg>
                </template>
            </div>
            <div class="md-body-1 capitalize" v-if="member.roles && member.roles.length && member.organization">{{ member.roles }}, {{ member.organization }}</div>
            <div class="md-body-1 capitalize" v-else-if="member.roles && member.roles.length && !member.organization">{{ member.roles }}</div>
            <div class="md-body-1 capitalize" v-else-if="!member.roles && member.organization">{{ member.organization }}</div>
            <div class="md-body-1 active-status font-18" v-if="member.member_status == true">Active</div>
            <!--<div class="md-body-1 capitalize" v-else>Title, Company</div>-->
          </template>
          <template v-if="member.member_status == false">
            <div class="md-body-1 unsubscribe font-18">Inactive</div>
          </template>
        </div>
        <div class="card skills">
          <ul class="card-killsblock" v-if="(member.isDeleted && member.isDeleted.status === true) || (member.unsubscribe && member.unsubscribe.status === 'unsubscribed')">
            <li>Status:</li>
            <li>
              <span v-if="member.isDeleted && member.isDeleted.status === true">
                <span >Deleted</span>
              </span>
              <span v-else-if="member.unsubscribe && member.unsubscribe.status === 'unsubscribed'">
                <span >Unsubscribed <br>{{member.unsubscribe.when | momentDate}}</span>
              </span>
            </li>
          </ul><ul class="card-killsblock">
            <li>Requests:<br/>Last Request:</li>
            <li>
              <span v-if="$lodash.has(member.request, 'totalRequest')">{{member.request.totalRequest}}</span>
              <span v-else>N/A</span>
              <br/><span v-if="$lodash.has(member.request, 'lastRequest')">{{member.request.lastRequest | momentDate}}</span>
              <span v-else>N/A</span>
            </li>
          </ul>

          <ul class="card-killsblock">
            <li>Last Request Received:<br>Next Engagement Date:</li>
            <li>
              <span v-if="$lodash.has(member.requestReceived, 'lastRequestReceived')">{{member.requestReceived.lastRequestReceived | momentDate}}</span>
              <span v-else>N/A</span>
              <br>
              <span v-if="$lodash.has(member, 'nextEngagementDate')">{{member.nextEngagementDate | momentDate}}</span>
              <span v-else>N/A</span>
            </li>
          </ul>

          <ul class="card-killsblock">
            <li>Responses:<br/>Last Response:</li>
            <li>
              <span v-if="$lodash.has(member.response, 'totalResponse')">{{member.response.totalResponse}}</span>
			  <span v-else>N/A</span><br/><span v-if="$lodash.has(member.response, 'lastResponse')">{{member.response.lastResponse | momentDate}}</span>
			  <span v-else>N/A</span>
            </li>
          </ul>
          <ul class="card-killsblock">
            <li>Feedback Given:</li>
            <li>
              <span v-if="member.feedback_given > 0">{{member.feedback_given}}</span>
			  <span v-else>N/A</span>
            </li>
          </ul>
          <ul class="card-killsblock">
            <li>Feedback Received:</li>
            <li>
              <span v-if="member.feedback_received > 0">{{member.feedback_received}}</span>
			  <span v-else>N/A</span>
            </li>
          </ul>
        </div>
      </div>
      <!-- End Right Column -->
      <!-- Left Column -->
      <div class="md-layout-item md-xlarge-size-66 md-large-size-66 md-small-size-100">
        <!-- Local Card -->
        <form @change.prevent="saveDetail('form-profile')" data-vv-scope="form-profile" class="textlable-spaceright">
            <div class="card local">
                <div class="card-row">
                    <div class="card-item md-subheading mt-30">Community</div>
                    <div class="md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100">
                        <md-field class="create-community w-50">
                            <md-select @md-closed="changeCommunity()" :disabled="member.isDeleted.status == true" v-model.trim="newComm" name="community" placeholder="Community" id="community">
                                <md-option v-for="(singleCommunity) in allCommunities" v-bind:key="singleCommunity._id" :value="singleCommunity._id">{{ singleCommunity.name }}</md-option>
                            </md-select>
                        </md-field>
                    </div>
                </div>
                <div class="card-row">
                    <div class="card-item md-subheading mt-30">Circles</div>
                    <div class="md-layout-item remove-perfect-tense">
                        <md-field class="create-community textareaAfter">
                            <md-textarea :disabled="member.isDeleted.status == true" v-model.lazy="circleList" name="circles" @input="circleList = sanitizeInput($event)" placeholder="Circles..." md-autogrow></md-textarea>
                            <span class="md-helper-text">Multiple skills must be comma(,) separated</span>
                        </md-field>
                    </div>
                </div>
                <div class="card-row">
                    <div class="card-item md-subheading mt-30">Groups</div>
                    <div class="md-layout-item remove-perfect-tense custom-textarea">
                        <md-field class="create-community textareaAfter">
                            <md-textarea :disabled="member.isDeleted.status == true" v-model.lazy="groups" @input="groups = sanitizeInput($event)" v-validate.continues="'max:500'" :maxlength="500" name="groups" placeholder="Groups" md-autogrow></md-textarea>
                            <span class="md-helper-text counter-padding">Multiple group must be comma(,) separated</span>
                        </md-field>
                    </div>
                </div>
                <div class="card-row">
                    <div class="card-item md-subheading mt-30">Member Type</div>
                    <div class="md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100">
                        <md-field class="create-community w-50">
                            <md-select @md-closed="saveDetail2('memberType', memberType)" :disabled="member.isDeleted.status == true" v-model.trim="memberType" name="memberType" placeholder="Member Type" id="memberType" class = "capitalize">
                                <md-option value="Advisor">Advisor</md-option>
                                <md-option value="Member">Member</md-option>
                                <md-option value="Referral">Referral</md-option>
                            </md-select>
                        </md-field>
                    </div>
                </div>
                <div class="card-row">
                    <div class="card-item md-subheading mt-30">Member Flag</div>
                    <div class="md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100">
                        <md-field class="create-community w-50">
                            <md-select @md-closed="saveDetail2('memberFlag', memberFlag)" :disabled="member.isDeleted.status == true" v-model="memberFlag" name="memberFlag" placeholder="Member Flag" id="memberFlag" class="capitalize">
                                <md-option value="Flagged">Flag Member</md-option>
                                <md-option value="Unflagged">Unflag Member</md-option>
                            </md-select>
                        </md-field>
                    </div>
                </div>
                <div class="card-row">
                    <div class="card-item md-subheading mt-30">Member Role</div>
                    <div class="md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100">
                        <md-field class="create-community">
                            <md-input :disabled="member.isDeleted.status == true" v-model.lazy="member.member_role" @input="member.member_role = sanitizeInput($event)" name="member_role" placeholder="Member Role" aria-label="Member Role"></md-input>
                        </md-field>
                    </div>
                </div>
                <div class="card-row">
                    <div class="card-item md-subheading mt-30">Member Rank</div>
                    <div class="md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100">
                        <md-field class="create-community textareaAfter">
                            <md-textarea :disabled="member.isDeleted.status == true" v-model.lazy="member.member_rank" @input="member.member_rank = sanitizeInput($event)" name="member_rank" placeholder="Member Rank" md-autogrow></md-textarea>
                            <span class="md-helper-text">Multiple member rank must be comma(,) separated</span>
                        </md-field>
                    </div>
                </div>
                <div class="card-row">
                    <div class="card-item md-subheading mt-30">Advice Area</div>
                    <div class="md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100">
                        <md-field class="create-community textareaAfter">
                            <md-textarea :disabled="member.isDeleted.status == true" v-model.lazy="member.advice_area" @input="member.advice_area = sanitizeInput($event)" name="advice_area" placeholder="Advice Area" md-autogrow></md-textarea>
                            <span class="md-helper-text">Multiple Advice Area must be comma(,) separated</span>
                        </md-field>
                    </div>
                </div>
                <div class="card-row">
                    <div class="card-item md-subheading mt-30">Affinity</div>
                    <div class="md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100">
                        <md-field class="create-community textareaAfter">
                            <md-textarea :disabled="member.isDeleted.status == true" v-model.lazy="member.affinity" @input="member.affinity = sanitizeInput($event)" name="affinity" placeholder="Affinity" md-autogrow></md-textarea>
                            <span class="md-helper-text">Multiple affinity must be comma(,) separated</span>
                        </md-field>
                    </div>
                </div>
                <div class="card-row">
                    <div class="card-item md-subheading mt-30">Property ID</div>
                    <div class="md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100">
                        <md-field class="create-community">
                            <md-input :disabled="member.isDeleted.status == true" v-model.lazy="member.propertyId" @input="member.propertyId = sanitizeInput($event)" name="propertyId" placeholder="Property Id"></md-input>
                        </md-field>
                    </div>
                </div>
                <div class="card-row">
                    <div class="card-item md-subheading mt-30">Student ID</div>
                    <div class="md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100">
                        <md-field class="create-community">
                            <md-input :disabled="member.isDeleted.status == true" v-model.lazy="member.studentId" @input="member.studentId = sanitizeInput($event)" name="studentId" placeholder="Student Id"></md-input>
                        </md-field>
                    </div>
                </div>
                <div class="card-row mprofile">
                    <div class="card-item md-subheading mt-30">First Name</div>
                    <div class="md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100">
                        <md-field class="create-community">
                            <md-input :disabled="member.isDeleted.status == true" v-model.lazy="member.first" @input="member.first = sanitizeInput($event)" name="first" v-validate="'required'" placeholder="First Name"></md-input>
                            <span class="md-helper-text error" v-show="errors.has('form-profile.first')">{{errors.first('form-profile.first')}}</span>
                        </md-field>
                        <!-- <p class="error m-left-5" v-show="errors.has('form-profile.first')">{{errors.first('form-profile.first')}}</p> -->
                    </div>
                </div>
                <div class="card-row ">
                    <div class="card-item md-subheading mt-30">Last Name</div>
                    <div class="md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100">
                        <md-field class="create-community">
                            <md-input :disabled="member.isDeleted.status == true" v-model.lazy="member.last" @input="member.last = sanitizeInput($event)" name="last" v-validate="'required'" placeholder="Last Name"></md-input>
                            <span class="md-helper-text error" v-show="errors.has('form-profile.last')">{{errors.first('form-profile.last')}}</span>
                        </md-field>
                        <!-- <p class="error m-left-5" v-show="errors.has('form-profile.last')">{{errors.first('form-profile.last')}}</p> -->
                    </div>
                </div>
                <!-- :disabled="member.isDeleted.status == true" -->
                <div class="card-row mt-30 update-email-field">
                    <div class="card-item md-subheading">Email Address</div>
                    <div class="md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100">
                        <md-field class="create-community" v-if="isEmailLinkDisable">
                            <md-input v-model.lazy="member.emails" @input="member.emails = sanitizeInput($event)" name="email" v-validate="'required|email'" placeholder="Email Address"></md-input>
                            <span class="md-helper-text error" v-show="errors.has('form-profile.email')">{{errors.first('form-profile.email')}}</span>
                        </md-field>
                        <div v-if="!isEmailLinkDisable">
                            <div class="card-item md-subheading" v-if="member.emails && member.emails.length">{{member.emails[0]}}</div>
                            <div class="card-item md-subheading empty-dash light" v-else></div>
                        </div>
                    </div>
                    <div v-if="!isEmailDisable && member.isDeleted.status == false && !member.unsubscribe">
                        <md-button type="button" v-on:click="isEmailLinkDisable = true" class="md-button md-red md-round md-accent md-theme-default">Update email</md-button>
                    </div>
                </div>
                <!-- <div class="card-row mt-20" v-if="member.isDeleted.status == true || isEmailLinkDisable">
                    <div class="card-item md-subheading ">Email Address</div>
                    <div class="card-item md-subheading light" v-if="member.emails && member.emails.length">{{member.emails[0]}}</div>
                    <div class="card-item md-subheading empty-dash light" v-else></div>
                </div> -->
                <div class="card-row">
                    <div class="card-item md-subheading mt-30">Email address 2</div>
                    <div class="md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100">
                        <md-field class="create-community">
                            <md-input :disabled="true" v-model.lazy="member.email_address2" @input="member.email_address2 = sanitizeInput($event)" name="email_address2" placeholder="Email Address 2"></md-input>
                        </md-field>
                    </div>
                </div>
                <div class="card-row">
                    <div class="card-item md-subheading mt-30">Email address 3</div>
                    <div class="md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100">
                        <md-field class="create-community">
                            <md-input :disabled="true" v-model.lazy="member.email_address3" @input="member.email_address3 = sanitizeInput($event)" name="email_address3" placeholder="Email Address 3"></md-input>
                        </md-field>
                    </div>
                </div>
                <div class="card-row">
                    <div class="card-item md-subheading mt-30">Phone</div>
                    <div class="md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100">
                        <md-field class="create-community">
                            <md-input :disabled="member.isDeleted.status == true" v-model.lazy="member.phoneNumbers" @input="member.phoneNumbers = sanitizeInput($event)" name="phoneNumbers" placeholder="Phone Numbers" aria-label="Phone Numbers"></md-input>
                        </md-field>
                    </div>
                </div>
                <div class="card-row">
                    <div class="card-item md-subheading mt-30">Role</div>
                    <div class="md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100">
                        <md-field class="create-community">
                            <md-input :disabled="member.isDeleted.status == true" v-model.lazy="member.roles" @input="member.roles = sanitizeInput($event)" name="roles" placeholder="Role" aria-label="Role"></md-input>
                        </md-field>
                    </div>
                </div>
                <div class="card-row">
                    <div class="card-item md-subheading mt-30">Role Description</div>
                    <div class="md-layout-item remove-perfect-tense">
                        <md-field class="create-community textareaAfter">
                            <md-textarea :disabled="member.isDeleted.status == true" v-model.lazy="member.roleDescription" @input="member.roleDescription = sanitizeInput($event)" v-validate.continues="'max:2000'" :maxlength="2000" name="roleDescription" placeholder="Role Description" md-autogrow></md-textarea>
                        </md-field>
                    </div>
                </div>
                <div class="card-row">
                    <div class="card-item md-subheading mt-30">Organization</div>
                    <div class="md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100">
                        <md-field class="create-community">
                            <md-input :disabled="member.isDeleted.status == true" v-model.lazy="member.organization" @input="member.organization = sanitizeInput($event)" name="organization" placeholder="Organization" aria-label="Organization"></md-input>
                        </md-field>
                    </div>
                </div>
                <div class="card-row">
                    <div class="card-item md-subheading mt-30">Organization Description</div>
                    <div class="md-layout-item remove-perfect-tense">
                        <md-field class="create-community textareaAfter">
                            <md-textarea :disabled="member.isDeleted.status == true" v-model.lazy="member.organizationDescription" @input="member.organizationDescription = sanitizeInput($event)" v-validate.continues="'max:2000'" :maxlength="2000" name="organizationDescription" placeholder="Organization Description" md-autogrow></md-textarea>
                        </md-field>
                    </div>
                </div>
                <div class="card-row">
                    <div class="card-item md-subheading mt-30">City</div>
                    <div class="md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100">
                        <md-field class="create-community">
                            <md-input :disabled="member.isDeleted.status == true" v-model.lazy="member.city" @input="member.city = sanitizeInput($event)" name="city" placeholder="City" aria-label="City"></md-input>
                        </md-field>
                    </div>
                </div>
                <div class="card-row">
                    <div class="card-item md-subheading mt-30">State</div>
                    <div class="md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100">
                        <md-field class="create-community">
                            <md-input :disabled="member.isDeleted.status == true" v-model.lazy="member.state" @input="member.state = sanitizeInput($event)" name="state" placeholder="State" aria-label="State"></md-input>
                        </md-field>
                    </div>
                </div>
                <div class="card-row">
                    <div class="card-item md-subheading mt-30">Postal Code</div>
                    <div class="md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100">
                        <md-field class="create-community">
                            <md-input :disabled="member.isDeleted.status == true" v-model.lazy="member.postal_code" @input="member.postal_code = sanitizeInput($event)" name="postal_code" placeholder="Postal Code"></md-input>
                        </md-field>
                    </div>
                </div>
                <div class="card-row">
                    <div class="card-item md-subheading mt-30">Country</div>
                    <div class="md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100">
                        <md-field class="create-community">
                            <md-input :disabled="member.isDeleted.status == true" v-model.lazy="member.country" @input="member.country = sanitizeInput($event)" name="country" placeholder="Country" aria-label="Country"></md-input>
                        </md-field>
                    </div>
                </div>
                <div class="card-row">
                    <div class="card-item md-subheading mt-30">Citizenship 1</div>
                    <div class="md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100">
                        <md-field class="create-community">
                            <md-input :disabled="member.isDeleted.status == true" v-model.lazy="member.citizenship1" @input="member.citizenship1 = sanitizeInput($event)" name="citizenship1" placeholder="Citizenship 1"></md-input>
                        </md-field>
                    </div>
                </div>
                <div class="card-row">
                    <div class="card-item md-subheading mt-30">Citizenship 2</div>
                    <div class="md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100">
                        <md-field class="create-community">
                            <md-input :disabled="member.isDeleted.status == true" v-model.lazy="member.citizenship2" @input="member.citizenship2 = sanitizeInput($event)" name="citizenship2" placeholder="Citizenship 2"></md-input>
                        </md-field>
                    </div>
                </div>
                <div class="card-row">
                    <div class="card-item md-subheading mt-30">Portal URL</div>
                    <div class="md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100">
                        <md-field class="create-community">
                            <md-input :disabled="member.isDeleted.status == true" v-model.lazy="member.portalURL" @input="member.portalURL = sanitizeUrl($event)" name="portalURL" placeholder="Portal URL"></md-input>
                        </md-field>
                    </div>
                </div>
                <div class="card-row">
                    <div class="card-item md-subheading mt-30">Industry</div>
                    <div class="md-layout-item remove-perfect-tense">
                        <md-field class="create-community textareaAfter">
                            <md-textarea :disabled="member.isDeleted.status == true" v-model.lazy="member.industry" @input="member.industry = sanitizeInput($event)" name="industry" placeholder="Industry" md-autogrow></md-textarea>
                            <span class="md-helper-text">Multiple industry must be comma(,) separated</span>
                        </md-field>
                    </div>
                </div>
                <div class="card-row">
                    <div class="card-item md-subheading mt-30">Bio</div>
                    <div class="md-layout-item remove-perfect-tense">
                        <md-field class="create-community textareaAfter">
                            <md-textarea :disabled="member.isDeleted.status == true" v-model.lazy="newBio" @input="newBio = sanitizeInput($event)" name="bio" placeholder="Bio..." md-autogrow></md-textarea>
                        </md-field>
                    </div>
                </div>
                <div class="card-row">
                    <div class="card-item md-subheading mt-30">Bio Keyword</div>
                    <div class="md-layout-item remove-perfect-tense">
                        <md-field class="create-community textareaAfter">
                            <md-textarea :disabled="member.isDeleted.status == true" v-model.lazy="newBioKeyword" @input="newBioKeyword = sanitizeInput($event)" name="newBioKeyword" placeholder="Bio Keyword..." md-autogrow></md-textarea>
                            <span class="md-helper-text">Multiple bio keywords must be comma(,) separated</span>
                        </md-field>
                    </div>
                </div>
                <div class="card-row">
                    <div class="card-item md-subheading mt-30">LinkedIn URL</div>
                    <div class="md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100">
                        <md-field class="create-community">
                            <md-input :disabled="member.isDeleted.status == true" v-model.lazy="member.linkedIn" @input="member.linkedIn = sanitizeUrl($event)" name="linkedInURL" placeholder="LinkedIn URL" v-validate="{ required: false, regex: /^http(s?)\:\/\/[0-9a-zA-Z]([-.\w]*[0-9a-zA-Z])*(:(0-9)*)*(\/?)([a-zA-Z0-9\-\.\?\,\'\/\\\+&amp;%\$#_]*)?$/ }"></md-input>
                            <span class="md-helper-text error" v-show="errors.has('form-profile.linkedInURL')">{{errors.first('form-profile.linkedInURL')}}</span>
                        </md-field>
                        <!-- <p class="error m-left-5" v-show="errors.has('form-profile.linkedInURL')">{{errors.first('form-profile.linkedInURL')}}</p> -->
                    </div>
                </div>
                <div class="card-row">
                    <div class="card-item md-subheading mt-30">Skills & Expertise</div>
                    <div class="md-layout-item remove-perfect-tense">
                        <md-field class="create-community textareaAfter">
                            <md-textarea :disabled="member.isDeleted.status == true" v-model.lazy="skillsList" @input="skillsList = sanitizeInput($event)" name="skills" placeholder="Skills..." md-autogrow></md-textarea>
                            <span class="md-helper-text">Multiple skills must be comma(,) separated</span>
                        </md-field>
                    </div>
                </div>
                <div class="card-row">
                    <div class="card-item md-subheading mt-30">Interests</div>
                    <div class="md-layout-item remove-perfect-tense">
                        <md-field class="create-community textareaAfter">
                            <md-textarea :disabled="member.isDeleted.status == true" v-model.lazy="interestList" @input="interestList = sanitizeInput($event)" name="interests" placeholder="Interests" md-autogrow></md-textarea>
                            <span class="md-helper-text">Multiple interests must be comma(,) separated</span>
                        </md-field>
                    </div>
                </div>
                <div class="card-row">
                    <div class="card-item md-subheading mt-30">Marketing Opt-In?</div>
                    <div class="md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100">
                        <md-field class="create-community">
                            <md-input :disabled="member.isDeleted.status == true" v-model.lazy="member.marketingOptIn" @input="member.marketingOptIn = sanitizeInput($event)" name="marketingOptIn" placeholder="Marketing Opt-In"></md-input>
                        </md-field>
                    </div>
                </div>
                <div class="card-row">
                    <div class="card-item md-subheading mt-30">Race</div>
                    <div class="md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100">
                        <md-field class="create-community">
                            <md-input :disabled="member.isDeleted.status == true" v-model.lazy="member.race" @input="member.race = sanitizeInput($event)" name="race" placeholder="Race"></md-input>
                        </md-field>
                    </div>
                </div>
                <div class="card-row">
                    <div class="card-item md-subheading mt-30">Gender</div>
                    <div class="md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100">
                        <md-field class="create-community">
                            <md-input :disabled="member.isDeleted.status == true" v-model.lazy="member.gender" @input="member.gender = sanitizeInput($event)" name="gender" placeholder="Gender"></md-input>
                        </md-field>
                    </div>
                </div>
                <div class="card-row">
                    <div class="card-item md-subheading mt-30">Age</div>
                    <div class="md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100">
                        <md-field class="create-community">
                            <md-input :disabled="member.isDeleted.status == true" v-model.lazy="member.age" @input="member.age = sanitizeInput($event)" name="age" placeholder="Age"></md-input>
                        </md-field>
                    </div>
                </div>
                <div class="card-row">
                    <div class="card-item md-subheading mt-30">Online Calendar URL</div>
                    <div class="md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100">
                        <md-field class="create-community">
                            <md-input :disabled="member.isDeleted.status == true" v-model.lazy="member.calendar" @input="member.calendar = sanitizeInput($event)" name="calendar" placeholder="Calendar"></md-input>
                        </md-field>
                    </div>
                </div>
                <div class="card-row">
                    <div class="card-item md-subheading mt-30">Twitter URL</div>
                    <div class="md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100">
                        <md-field class="create-community">
                            <md-input :disabled="member.isDeleted.status == true" v-model.lazy="member.twitter" @input="member.twitter = sanitizeUrl($event)" name="twitter" placeholder="Twitter URL"></md-input>
                        </md-field>
                    </div>
                </div>
                <div class="card-row">
                    <div class="card-item md-subheading mt-30">Instagram URL</div>
                    <div class="md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100">
                        <md-field class="create-community">
                            <md-input :disabled="member.isDeleted.status == true" v-model.lazy="member.instagram" @input="member.instagram = sanitizeUrl($event)" name="instagram" placeholder="Instagram URL"></md-input>
                        </md-field>
                    </div>
                </div>
                <div class="card-row">
                    <div class="card-item md-subheading mt-30">Skype ID</div>
                    <div class="md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100">
                        <md-field class="create-community">
                            <md-input :disabled="member.isDeleted.status == true" v-model.lazy="member.skypeID" @input="member.skypeID = sanitizeInput($event)" name="skypeID" placeholder="Skype ID"></md-input>
                        </md-field>
                    </div>
                </div>
                <div class="card-row">
                    <div class="card-item md-subheading mt-30">School 1</div>
                    <div class="md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100">
                        <md-field class="create-community">
                            <md-input :disabled="member.isDeleted.status == true" v-model.lazy="member.school1" @input="member.school1 = sanitizeInput($event)" name="school1" placeholder="School 1"></md-input>
                        </md-field>
                    </div>
                </div>
                <div class="card-row">
                    <div class="card-item md-subheading mt-30">Department 1</div>
                    <div class="md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100">
                        <md-field class="create-community">
                            <md-input :disabled="member.isDeleted.status == true" v-model.lazy="member.department1" @input="member.department1 = sanitizeInput($event)" name="department1" placeholder="Department 1"></md-input>
                        </md-field>
                    </div>
                </div>
                <div class="card-row">
                    <div class="card-item md-subheading mt-30">Major 1</div>
                    <div class="md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100">
                        <md-field class="create-community">
                            <md-input :disabled="member.isDeleted.status == true" v-model.lazy="member.major1" @input="member.major1 = sanitizeInput($event)" name="major1" placeholder="Major 1"></md-input>
                        </md-field>
                    </div>
                </div>
                <div class="card-row">
                    <div class="card-item md-subheading mt-30">Degree 1</div>
                    <div class="md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100">
                        <md-field class="create-community">
                            <md-input :disabled="member.isDeleted.status == true" v-model.lazy="member.degree1" @input="member.degree1 = sanitizeInput($event)" name="degree1" placeholder="Degree 1"></md-input>
                        </md-field>
                    </div>
                </div>
                <div class="card-row">
                    <div class="card-item md-subheading mt-30">Year 1</div>
                    <div class="md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100">
                        <md-field class="create-community">
                            <md-input :disabled="member.isDeleted.status == true" v-model.lazy="member.year1" @input="member.year1 = sanitizeInput($event)" name="year1" placeholder="Year 1"></md-input>
                        </md-field>
                    </div>
                </div>
                <div class="card-row">
                    <div class="card-item md-subheading mt-30">School 2</div>
                    <div class="md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100">
                        <md-field class="create-community">
                            <md-input :disabled="member.isDeleted.status == true" v-model.lazy="member.school2" @input="member.school2 = sanitizeInput($event)" name="school2" placeholder="School 2"></md-input>
                        </md-field>
                    </div>
                </div>
                <div class="card-row">
                    <div class="card-item md-subheading mt-30">Department 2</div>
                    <div class="md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100">
                        <md-field class="create-community">
                            <md-input :disabled="member.isDeleted.status == true" v-model.lazy="member.department2" @input="member.department2 = sanitizeInput($event)" name="department2" placeholder="Department 2"></md-input>
                        </md-field>
                    </div>
                </div>
                <div class="card-row">
                    <div class="card-item md-subheading mt-30">Major 2</div>
                    <div class="md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100">
                        <md-field class="create-community">
                            <md-input :disabled="member.isDeleted.status == true" v-model.lazy="member.major2" @input="member.major2 = sanitizeInput($event)" name="major2" placeholder="Major 2"></md-input>
                        </md-field>
                    </div>
                </div>
                <div class="card-row">
                    <div class="card-item md-subheading mt-30">Degree 2</div>
                    <div class="md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100">
                        <md-field class="create-community">
                            <md-input :disabled="member.isDeleted.status == true" v-model.lazy="member.degree2" @input="member.degree2 = sanitizeInput($event)" name="degree2" placeholder="Degree 2"></md-input>
                        </md-field>
                    </div>
                </div>
                <div class="card-row">
                    <div class="card-item md-subheading mt-30">Year 2</div>
                    <div class="md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100">
                        <md-field class="create-community">
                            <md-input :disabled="member.isDeleted.status == true" v-model.lazy="member.year2" @input="member.year2 = sanitizeInput($event)" name="year2" placeholder="Year 2"></md-input>
                        </md-field>
                    </div>
                </div>
                <div class="card-row">
                    <div class="card-item md-subheading mt-30">School 3</div>
                    <div class="md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100">
                        <md-field class="create-community">
                            <md-input :disabled="member.isDeleted.status == true" v-model.lazy="member.school3" @input="member.school3 = sanitizeInput($event)" name="school3" placeholder="School 3"></md-input>
                        </md-field>
                    </div>
                </div>
                <div class="card-row">
                    <div class="card-item md-subheading mt-30">Department 3</div>
                    <div class="md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100">
                        <md-field class="create-community">
                            <md-input :disabled="member.isDeleted.status == true" v-model.lazy="member.department3" @input="member.department3 = sanitizeInput($event)" name="department3" placeholder="Department 3"></md-input>
                        </md-field>
                    </div>
                </div>
                <div class="card-row">
                    <div class="card-item md-subheading mt-30">Major 3</div>
                    <div class="md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100">
                        <md-field class="create-community">
                            <md-input :disabled="member.isDeleted.status == true" v-model.lazy="member.major3" @input="member.major3 = sanitizeInput($event)" name="major3" placeholder="Major 3"></md-input>
                        </md-field>
                    </div>
                </div>
                <div class="card-row">
                    <div class="card-item md-subheading mt-30">Degree 3</div>
                    <div class="md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100">
                        <md-field class="create-community">
                            <md-input :disabled="member.isDeleted.status == true" v-model.lazy="member.degree3" @input="member.degree3 = sanitizeInput($event)" name="degree3" placeholder="Degree 3"></md-input>
                        </md-field>
                    </div>
                </div>
                <div class="card-row">
                    <div class="card-item md-subheading mt-30">Year 3</div>
                    <div class="md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100">
                        <md-field class="create-community">
                            <md-input :disabled="member.isDeleted.status == true" v-model.lazy="member.year3" @input="member.year3 = sanitizeInput($event)" name="year3" placeholder="Year 3"></md-input>
                        </md-field>
                    </div>
                </div>
                <div class="card-row">
                    <div class="card-item md-subheading mt-30">School 4</div>
                    <div class="md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100">
                        <md-field class="create-community">
                            <md-input :disabled="member.isDeleted.status == true" v-model.lazy="member.school4" @input="member.school4 = sanitizeInput($event)" name="school4" placeholder="School 4"></md-input>
                        </md-field>
                    </div>
                </div>
                <div class="card-row">
                    <div class="card-item md-subheading mt-30">Department 4</div>
                    <div class="md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100">
                        <md-field class="create-community">
                            <md-input :disabled="member.isDeleted.status == true" v-model.lazy="member.department4" @input="member.department4 = sanitizeInput($event)" name="department4" placeholder="Department 4"></md-input>
                        </md-field>
                    </div>
                </div>
                <div class="card-row">
                    <div class="card-item md-subheading mt-30">Major 4</div>
                    <div class="md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100">
                        <md-field class="create-community">
                            <md-input :disabled="member.isDeleted.status == true" v-model.lazy="member.major4" @input="member.major4 = sanitizeInput($event)" name="major4" placeholder="Major 4"></md-input>
                        </md-field>
                    </div>
                </div>
                <div class="card-row">
                    <div class="card-item md-subheading mt-30">Degree 4</div>
                    <div class="md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100">
                        <md-field class="create-community">
                            <md-input :disabled="member.isDeleted.status == true" v-model.lazy="member.degree4" @input="member.degree4 = sanitizeInput($event)" name="degree4" placeholder="Degree 4"></md-input>
                        </md-field>
                    </div>
                </div>
                <div class="card-row">
                    <div class="card-item md-subheading mt-30">Year 4</div>
                    <div class="md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100">
                        <md-field class="create-community">
                            <md-input :disabled="member.isDeleted.status == true" v-model.lazy="member.year4" @input="member.year4 = sanitizeInput($event)" name="year4" placeholder="Year 4"></md-input>
                        </md-field>
                    </div>
                </div>
                <div class="card-row">
                    <div class="card-item md-subheading mt-30">School 5</div>
                    <div class="md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100">
                        <md-field class="create-community">
                            <md-input :disabled="member.isDeleted.status == true" v-model.lazy="member.school5" @input="member.school5 = sanitizeInput($event)" name="school5" placeholder="School 5"></md-input>
                        </md-field>
                    </div>
                </div>
                <div class="card-row">
                    <div class="card-item md-subheading mt-30">Department 5</div>
                    <div class="md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100">
                        <md-field class="create-community">
                            <md-input :disabled="member.isDeleted.status == true" v-model.lazy="member.department5" @input="member.department5 = sanitizeInput($event)" name="department5" placeholder="Department 5"></md-input>
                        </md-field>
                    </div>
                </div>
                <div class="card-row">
                    <div class="card-item md-subheading mt-30">Major 5</div>
                    <div class="md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100">
                        <md-field class="create-community">
                            <md-input :disabled="member.isDeleted.status == true" v-model.lazy="member.major5" @input="member.major5 = sanitizeInput($event)" name="major5" placeholder="Major 5"></md-input>
                        </md-field>
                    </div>
                </div>
                <div class="card-row">
                    <div class="card-item md-subheading mt-30">Degree 5</div>
                    <div class="md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100">
                        <md-field class="create-community">
                            <md-input :disabled="member.isDeleted.status == true" v-model.lazy="member.degree5" @input="member.degree5 = sanitizeInput($event)" name="degree5" placeholder="Degree 5"></md-input>
                        </md-field>
                    </div>
                </div>
                <div class="card-row">
                    <div class="card-item md-subheading mt-30">Year 5</div>
                    <div class="md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100">
                        <md-field class="create-community">
                            <md-input :disabled="member.isDeleted.status == true" v-model.lazy="member.year5" @input="member.year5 = sanitizeInput($event)" name="year5" placeholder="Year 5"></md-input>
                        </md-field>
                    </div>
                </div>
                <div class="card-row">
                    <div class="card-item md-subheading mt-30">Image URL</div>
                    <div class="md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100">
                        <md-field class="create-community">
                            <md-input :disabled="member.isDeleted.status == true" v-model.lazy="member.imageURL" @input="member.imageURL = sanitizeInput($event)" name="imageURL" placeholder="Image URL"></md-input>
                        </md-field>
                    </div>
                </div>
                <div class="card-row">
                    <div class="card-item md-subheading mt-30">Website URL</div>
                    <div class="md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100">
                        <md-field class="create-community">
                            <md-input :disabled="member.isDeleted.status == true" v-model.lazy="member.website" @input="member.website = sanitizeUrl($event)" name="website" placeholder="Website URL"></md-input>
                        </md-field>
                    </div>
                </div>
                <div class="card-row">
                    <div class="card-item md-subheading mt-30">Facebook URL</div>
                    <div class="md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100">
                        <md-field class="create-community">
                            <md-input :disabled="member.isDeleted.status == true" v-model.lazy="member.facebook" @input="member.facebook = sanitizeUrl($event)" name="facebook" placeholder="Facebook URL"></md-input>
                        </md-field>
                    </div>
                </div>
                <div class="card-row">
                    <div class="card-item md-subheading mt-30">Company Stage</div>
                    <div class="md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100">
                        <md-field class="create-community">
                            <md-input v-model.lazy="member.companyStage" @input="member.companyStage = sanitizeInput($event)" name="companyStage" placeholder="Company Stage"></md-input>
                        </md-field>
                    </div>
                </div>
                <div class="card-row">
                    <div class="card-item md-subheading mt-30">Annual Revenue</div>
                    <div class="md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100">
                        <md-field class="create-community">
                            <md-input v-model.lazy="member.annualRevenue" @input="member.annualRevenue = sanitizeInput($event)" name="annualRevenue" placeholder="Annual Revenue"></md-input>
                        </md-field>
                    </div>
                </div>
                <div class="card-row">
                    <div class="card-item md-subheading mt-30">Team Size</div>
                    <div class="md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100">
                        <md-field class="create-community">
                            <md-input v-model.trim="member.teamSize" @input="member.teamSize = sanitizeInput($event)" name="teamSize" placeholder="Team Size"></md-input>
                        </md-field>
                    </div>
                </div>
                <div class="card-row">
                    <div class="card-item md-subheading mt-30">WordPress Link</div>
                    <div class="md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100">
                        <md-field class="create-community">
                            <md-input v-model.trim="member.wordPressLink" @input="member.wordPressLink = sanitizeUrl($event)" name="wordPressLink" disabled></md-input>
                        </md-field>
                    </div>
                </div>
                <div class="card-row">
                    <div class="card-item md-subheading mt-30">Custom Value 1</div>
                    <div class="md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100">
                        <md-field class="create-community">
                            <md-input v-model.trim="member.customer_custom1" @input="member.customer_custom1 = sanitizeInput($event)" name="Custom Value 1"></md-input>
                        </md-field>
                    </div>
                </div>
                <div class="card-row">
                    <div class="card-item md-subheading mt-30">Custom Value 2</div>
                    <div class="md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100">
                        <md-field class="create-community">
                            <md-input v-model.trim="member.customer_custom2" @input="member.customer_custom2 = sanitizeInput($event)" name="Custom Value 2"></md-input>
                        </md-field>
                    </div>
                </div>
                <div class="card-row">
                    <div class="card-item md-subheading mt-30">Custom Value 3</div>
                    <div class="md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100">
                        <md-field class="create-community">
                            <md-input v-model.trim="member.customer_custom3" @input="member.customer_custom3 = sanitizeInput($event)" name="Custom Value 3"></md-input>
                        </md-field>
                    </div>
                </div>
                <div class="card-row">
                    <div class="card-item md-subheading mt-30">Engagement Points</div>
                    <div class="md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100">
                        <md-field class="create-community">
                            <md-input v-model.trim="member.engagementPoints" @input="member.engagementPoints = sanitizeInput($event)" name="engagementPoints" disabled></md-input>
                        </md-field>
                    </div>
                </div>
                <div class="card-row">
                    <div class="card-item md-subheading mt-30">Approved for Requests?</div>
                    <div class="md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100">
                        <md-field class="create-community w-50">
                            <md-select @md-closed="saveDetail2('requestStatus', requestStatus)" :disabled="member.isDeleted.status == true" v-model.trim="requestStatus" name="requestStatus" placeholder="Approved for Requests?" id="requestStatus" class="capitalize">
                                <md-option value="yes">Yes</md-option>
                                <md-option value="no">No</md-option>
                            </md-select>
                        </md-field>
                    </div>
                </div>
                <div class="card-row">
                    <div class="card-item md-subheading mt-30">Approved for responses?</div>
                    <div class="md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100">
                        <md-field class="create-community w-50">
                            <md-select @md-closed="saveDetail2('responseStatus', responseStatus)" :disabled="member.isDeleted.status == true" v-model.trim="responseStatus" name="responseStatus" placeholder="Approved for responses?" id="responseStatus" class="capitalize">
                                <md-option value="yes">Yes</md-option>
                                <md-option value="no">No</md-option>
                            </md-select>
                        </md-field>
                    </div>
                </div>
                <div class="card-row">
                    <div class="card-item md-subheading mt-30">Terms Accepted</div>
                    <div class="md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100">
                        <md-field class="create-community w-50">
                            <md-input :value="member.termsAccepted | momentDate" name="termsAccepted" disabled v-if="member.termsAccepted" @input="member.termsAccepted = sanitizeInput($event)"></md-input>
                            <md-input name="termsAccepted" disabled v-else></md-input>
                        </md-field>
                    </div>
                </div>
                <div class="card-row">
                    <div class="card-item md-subheading mt-30">Frequency</div>
                    <div class="md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100">
                        <md-field class="create-community w-50">
                            <md-select @md-closed="saveDetail2('frequency', frequency)" v-model.trim="frequency" name="frequency" placeholder="Frequency" class="capitalize">
                                <md-option :value="frequency" :key="frequency" v-for="frequency in availableFrequncy">{{toTitleCase(frequency)}}</md-option>
                            </md-select>
                        </md-field>
                    </div>
                </div>
                <div class="card-row">
                    <div class="card-item md-subheading mt-30">Engagement</div>
                    <div class="md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100">
                        <md-field class="create-community">
                            <md-input v-model.trim="member.engagement" name="engagement" @input="member.engagement = sanitizeInput($event)"></md-input>
                        </md-field>
                    </div>
                </div>
                <div class="card-row">
                    <div class="card-item md-subheading mt-30">Capacity</div>
                    <div class="md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100">
                        <md-field class="create-community">
                            <md-input v-model.trim="member.capacity" name="capacity" @input="member.capacity = sanitizeInput($event)"></md-input>
                        </md-field>
                    </div>
                </div>
                <div class="card-row">
                    <div class="card-item md-subheading mt-30">Propensity</div>
                    <div class="md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100">
                        <md-field class="create-community">
                            <md-input v-model.trim="member.propensity" name="propensity" @input="member.propensity = sanitizeInput($event)"></md-input>
                        </md-field>
                    </div>
                </div>
                <div class="card-row">
                    <div class="card-item md-subheading mt-30">Member Status</div>
                    <div class="md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100">
                        <md-field class="create-community w-50">
                            <md-select @md-closed="saveDetail2('member_status', member_status)" v-model.trim="member_status" name="member_status" placeholder="member_status" class="capitalize">
                                <md-option :value="true">Active</md-option>
                                <md-option :value="false">Inactive</md-option>
                            </md-select>
                        </md-field>
                    </div>
                </div>
                <div class="card-row">
                    <div class="card-item md-subheading mt-30">Account Owner</div>
                    <div class="md-layout-item remove-perfect-tense">
                        <md-field class="create-community textareaAfter">
                            <md-textarea :disabled="member.isDeleted.status == true" v-model.lazy="accountOwnerList" @input="accountOwnerList = sanitizeInput($event)" name="account_owner" placeholder="Account Owner..." md-autogrow></md-textarea>
                            <span class="md-helper-text">Multiple account owner must be comma(,) separated</span>
                        </md-field>
                    </div>
                </div>
                <div class="card-row cardbtndel pull-right">
                    <md-button type="button" @click="deleteMember()" v-if="member.isDeleted.status == false || typeof member.isDeleted == 'undefined'" class="md-button md-red md-round md-accent md-theme-default">Delete Member</md-button>
                </div>
            </div>
        </form>
        <!-- End Local Card -->
      </div>
      <!-- End Left Column -->
    </div>
  </div>
</template>
<style>

</style>

<!-- Script-->
<script>
import API from "../services/API";
import { sanitizeInput, sanitizeUrl } from '@/utils/sanitizer';
export default {
  data() {
    return {
      api: new API(),
      member: {
        isDeleted: {}
      },
      community: {},
      circleList: [],
      skillsList: [],
      fullPage: true,
      interestList: [],
      allCommunities: [],
      expertiseList: [],
      newComm: "",
      newBio: "",
      newBioKeyword: "",
      feedback: 0,
      availableFrequncy: ['once a quarter', 'once a week', 'once a month', 'biweekly', 'daily', 'as often as needed'],
      member_status: '',
      memberType: '',
      memberFlag: '',
      frequency: '',
      capacity: '',
      propensity: '',
      requestStatus: '',
      responseStatus: '',
      groups: [],
      isEmailDisable: false,
      isEmailLinkDisable: false,
      accountOwnerList: []
    };
  },
  created() {
      const dict = {
  		custom: {
  			linkedInURL: {
  				regex: "Please enter a valid URL"
  			}
  		}
  	};
  	this.$validator.localize('en', dict);
    this.getFeedback();
    this.loadData();
    this.getAllCommunity();
  },
  methods: {
    sanitizeInput(event) {
        return sanitizeInput(event);
    },
    sanitizeUrl(event) {
        return sanitizeUrl(event);
    },
    loadData: async function() {
      await this.api.get(`members/${this.$route.params.member_id}`).then(member => {
        // console.log("member:", member);
        this.member = member.data;
        if (member.data.memberType) {
          this.memberType = member.data.memberType;
        }
        if (member.data.frequency) {
          this.frequency = member.data.frequency;
        }
        if (member.data.capacity) {
          this.capacity = member.data.capacity;
        }
        if (member.data.propensity) {
          this.propensity = member.data.propensity;
        }
        if (member.data.requestStatus) {
          this.requestStatus = member.data.requestStatus;
        }
        if (member.data.responseStatus) {
          this.responseStatus = member.data.responseStatus;
        }
        this.member_status = member.data.member_status;
        if (member.data && member.data.roles && member.data.roles.length) {
        	this.member.roles = member.data.roles.join(',');
        }
        if (member.data && member.data.emails && member.data.emails.length && member.data.email_address2 && member.data.email_address3) {
            this.isEmailDisable = true;
        }
        this.groups = this.member.groups;
        this.newBio = this.member.bio;
        this.newComm = this.member.community;
        var trimBioKeywords = this.member.bioKeywords.toString().replace(/ /g, '');
        this.newBioKeyword = trimBioKeywords.replace(/,/g, ", ");
        // this.newBioKeyword = this.member.bioKeywords.toString().replace(/,/g, ", ");
        this.skillsList = this.member.skills.toString().replace(/,/g, ", ");
        this.circleList = this.member.circles.toString().replace(/,/g, ", ");
        this.accountOwnerList = this.member.account_owner.toString().replace(/,/g, ", ");
        this.interestList = this.member.interests;
        if (this.member.memberType === "advisor") {
            this.memberType = "Advisor";
        } else if (this.member.memberType === "member") {
            this.memberType = "Member";
        } else if (this.member.memberType === "referral") {
            this.memberType = "Referral";
        }
        if (this.member.memberFlag === "Unflagged") {
            this.memberFlag = "Unflagged";
        } else if (this.member.memberFlag === "Flagged") {
            this.memberFlag = "Flagged";
        }
        if (!this.member.frequency) {
            this.member.frequency = "once a week";
        }
      });
      if (this.member && this.member.community) {
        await this.api.get(`communities/id/${this.member.community}`).then(community => {
          this.community = community.data;
        });
      }
      this.$validator.errors.clear();
      this.$validator.reset()
    },
    getFeedback: async function () {
      await this.api.post(`members/feedback/${this.$route.params.member_id}`).then(memberFeedback => {
        this.feedback = memberFeedback.data;
      });
    },
    saveDetail: async function(scope) {
        console.log("save details [h]: ", scope);
        if (typeof this.member._id !== 'undefined') {
            this.$validator.validateAll(scope).then(async (result) => {
                if (result) {
                    this.member.skills = this.skillsList;
                    this.member.circles = this.circleList;
                    this.member.account_owner = this.accountOwnerList;
                    this.member.interests = this.interestList;
                    if (this.newBio !== this.member.bio) {
                        await this.getKeywords(this.newBio);
                    }
                    this.member.groups = this.groups;
                    this.member.bio = this.newBio;
                    await this.api.post(`members/update-profile/${this.$route.params.member_id}`, this.member).then(member => {
                        this.loadData();
                        this.isEmailLinkDisable = false;
                        this.member = member.data.memberData;
                        if (member.data.isEmailExist) {
                            this.$toast.error('Email address already exist', {
                                position: 'top-right'
                            });
                        }
                        if (this.newBio === this.member.bio) {
                        }
                    });
                }
            });
        }
    },
    saveDetail2: async function(field, value) {
      var payload = {};
      if (field === 'memberType' && value !== this.member[field]) {
        payload = {memberType: this.memberType, community: this.member.community};
      }
      if (field === 'memberFlag' && value !== this.member[field]) {
        payload = {memberFlag: this.memberFlag, community: this.member.community};
      }
      if (field === 'frequency' && value !== this.member[field]) {
        payload = {frequency: this.frequency};
      }
      if (field === 'requestStatus' && value !== this.member[field]) {
        payload = {requestStatus: this.requestStatus};
      }
      if (field === 'responseStatus' && value !== this.member[field]) {
        payload = {responseStatus: this.responseStatus};
      }
      if (field === 'member_status' && value !== this.member[field]) {
        if (value === true) {
            this.subscribeMember();
        } else if (value === false) {
            this.unsubscribeMember();
        }
        payload = {member_status: this.member_status};
      }
      var checkDataExists = Object.entries(payload);
      if (checkDataExists.length) {
        await this.api.post(`members/update-profile-fields/${this.$route.params.member_id}`, payload).then(member => {
          this.loadData();
          this.member = member.data;
        });
      }
    },
    getKeywords: async function(Keywords) {
        await this.api.post(`members/update-bio-keyword/${this.$route.params.member_id}`, {bioKeywords: Keywords}).then(member => {
            // this.loadData();
            if (member.data.bioKeywords.length) {
                let trimBioKeywords = member.data.bioKeywords.toString().replace(/ /g, '');
                this.newBioKeyword = trimBioKeywords.replace(/,/g, ", ");
            }
        });
    },
    getAllCommunity: async function () {
      await this.api.get(`communities/all`).then(communities => {
        this.allCommunities = communities.data;
      });
    },
    changeCommunity: async function () {
      var selComm = this.newComm;
      var oldComm = "";
      if (typeof this.community._id !== 'undefined' || typeof this.member.community !== 'undefined') {
        oldComm = this.community._id ? this.community._id : this.member.community ? this.member.community : '';
      }

      if (selComm !== oldComm) {
        var parameters = {};
        parameters.selComm = this.newComm;
        parameters.oldComm = oldComm;
        await this.api.post(`members/update-user-community/${this.$route.params.member_id}`, parameters).then(member => {
          this.loadData();
          this.member = member.data;
        });
      }
    },
    deleteMember: async function () {
      await this.api.post(`members/delete/${this.$route.params.member_id}`).then(member => {
          this.member = member.data;
        });
    },
    toTitleCase(str) {
      return str.replace(
          /\w\S*/g,
          function(txt) {
              return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
          }
      );
    },
    unsubscribeMember: async function () {
        // Before calling toString, ensuring the variable is not undefined
        const emails = this.member.emails;
        const emailsString = (emails && emails.toString()) || 'No emails available';
        if (this.member.community) {
            const unsubscribe = {
                unsubscribe:
                {
                    email: emailsString,
                    reason: '',
                    description: ''
                },
                community: this.member.community,
                isMailSent: false,
                memberId: this.member._id,
                // Member directory profile — someone else unsubscribed this member
                // (api member/unsubscribeSource.js).
                source: 'admin'
            }
            await this.api.post('members/unsubscribe', unsubscribe).then(response => {
                this.loadData();
                this.$toast.success('Success! Member has been deactivated', {
                    position: 'top-right'
                }); // success toast
            }).catch(error => {
                // Assuming the error is caught internally and passed here
                console.error('Error during API call:', error); // Log the error for debugging
                this.$toast.error('Failed to deactivate member. Please try again later.', {
                    position: 'top-right'
                }); // error toast
            });
        } else {
            this.$toast.error('Member does not belong to a community. Please assign one.', {
                position: 'top-right'
            }); // error toast
        }
    },
    subscribeMember: async function () {
        // Before calling toString, ensuring the variable is not undefined
        const emails = this.member.emails;
        const emailsString = (emails && emails.toString()) || 'No emails available';

        if (this.member.community) {
            const data = {
                memberId: this.member._id,
                email: emailsString,
                communityId: this.member.community
            }
            await this.api.post(`/members/subscribe`, data).then(async response => {
                this.loadData();
                this.$toast.success('Success! Member has been activated', {
                    position: 'top-right'
                }); // success toast
            }).catch(error => {
                // Assuming the error is caught internally and passed here
                console.error('Error during API call:', error); // Log the error for debugging
                this.$toast.error('Failed to activate member. Please try again later.', {
                    position: 'top-right'
                }); // error toast
            });
        } else {
            this.$toast.error('Member does not belong to a community. Please assign one.', {
                    position: 'top-right'
                }); // error toast
        }
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/MemberProfile.vue